module.exports = __webpack_public_path__ + "media/images/bar-chart-75a6cd1369ef99db2a1853d3d04bd92f.svg";